import Container from '@/components/Container/Container';
import { SkeletonType } from '@/shared/types/layoutTypes';
import { Icon } from '@/shared/ui/Icon/Icon';
import clsx from 'clsx';
import { useState } from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styles from './_components/JobListing.module.scss';

export const JobSkeleton = (props: SkeletonType) => {
    const [hoveredRowIndex, setHoveredRowIndex] = useState(-1); // Track hovered row's index

    const handleMouseEnter = (index: number) => setHoveredRowIndex(index);
    const handleMouseLeave = () => setHoveredRowIndex(-1);

    const { items, isDark } = props;

    const getColors = (isCurrentRowHovered: boolean) => {
        if (isCurrentRowHovered) {
            return {
                baseColor: isDark ? 'var(--core60)' : 'var(--core10)',
                highlightColor: isDark ? 'var(--core70)' : 'var(--core15)',
            };
        }
        return {
            baseColor: isDark ? 'var(--core10)' : 'var(--core80)',
            highlightColor: isDark ? 'var(--core15)' : 'var(--core95)',
        };
    };

    return (
        <Container code="fullpage" className={{ wrap: clsx(styles.root, { [styles.dark]: isDark }) }}>
            {Array.from({ length: items }).map((_, index) => {
                const isCurrentRowHovered = index === hoveredRowIndex;
                const { baseColor, highlightColor } = getColors(isCurrentRowHovered);

                return (
                    <div
                        className={styles.row}
                        key={index}
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={handleMouseLeave}
                    >
                        <Container code="standard" className={{ wrap: styles.skeletonContainer }}>
                            <div>
                                <SkeletonTheme baseColor={baseColor} highlightColor={highlightColor}>
                                    <Skeleton width={250} height={24} />
                                    <Skeleton width={40} height={10} style={{ marginBottom: '12px' }} />
                                    <Skeleton width={200} height={20} />
                                </SkeletonTheme>
                            </div>
                            <Icon name="arrow_forward" className={styles.icon} />
                        </Container>
                    </div>
                );
            })}
        </Container>
    );
};
